const dashboards = {
  title: 'Dashboards',
  addDashboard: 'Add Dashboard',
  addFirstDashboard: 'Add First Dashboard',
  removeDashboard: 'Remove Dashboard',
  editDashboard: 'Edit Dashboard',
  pinDashboard: 'Pin Dashboard',
  unpinDashboard: 'Remove',
  exportCSV: 'Export CSV',
  settings: 'Settings',
  settingsDescription: 'Configure dashboard size and filters',
  refresh: 'Refresh',
  size: 'Size',
  filters: 'Filters',
  dateRangeNotImplemented: 'Date range (coming soon)',

  // Dashboard table column labels. Resolved by `field` when the template stores
  // the label as a plain (English-only) string (legacy). Templates with an
  // {en,pt} label take precedence and never reach this map.
  columns: {
    full_name: 'User',
    email: 'Email',
    event_count: 'Events',
    rating: 'Rating',
    comment: 'Comment',
    submitted_at: 'Date',
    first_seen_at: 'Date',
    title: 'Title',
    scheduled: 'Scheduled',
    joined_count: 'Joined',
    transcribed: 'Transcribed',
    errored: 'Errors',
    top_model: 'Top Model',
    models_count: 'Models',
    total_tokens: 'Tokens',
    total_calls: 'Calls',
    total_cost_usd: 'Cost (USD)',
  },

  sizes: {
    small: 'Small',
    medium: 'Medium',
    large: 'Large',
    full: 'Full',
  },
  noDashboards: 'No dashboards configured',
  noDashboardsDescription: 'Add dashboards to view your metrics and analytics',
  noDashboardsAvailable: 'No dashboards available',
  loadingDashboards: 'Loading dashboards...',
  errorLoading: 'Error loading data',
  noData: 'No data available',
  retry: 'Try again',
  confirmRemove: 'Are you sure you want to remove this dashboard?',
  addSuccess: 'Dashboard added successfully',
  addError: 'Error adding dashboard',
  removeSuccess: 'Dashboard removed successfully',
  removeError: 'Error removing dashboard',
  unsupportedChartType: 'Unsupported chart type',
  
  addDashboardDescription: 'Choose available dashboards to add to your view',
  searchDashboards: 'Search dashboards...',
  allCategories: 'All',
  add: 'Add',
  
  categories: {
    metrics: 'Tools',
    analytics: 'Analytics',
    reports: 'Reports',
  },
  
  chartTypes: {
    line: 'Line',
    bar: 'Bar',
    pie: 'Pie',
    donut: 'Donut',
    gauge: 'Gauge',
    area: 'Area',
    scatter: 'Scatter',
  },

  dateRange: {
    selectPeriod: 'Select period',
    last7Days: 'Last 7 days',
    last14Days: 'Last 14 days',
    last30Days: 'Last 30 days',
    last60Days: 'Last 60 days',
    last90Days: 'Last 90 days',
    last6Months: 'Last 6 months',
    lastYear: 'Last year',
    custom: 'Custom range',
    startDate: 'Start date',
    endDate: 'End date',
    selectDate: 'Select date',
  },
  export: {
    success: "Success!",
    successDescription: "Data exported successfully.",
    error: "Error",
    errorDescription: "Error exporting data. Please try again.",
  },

  formFactor: {
    tile: 'Tile',
    graph: 'Graph',
    table: 'Table',
    hero: 'Highlight',
  },

  layouts: {
    freeGrid: 'No layout',
    myLayouts: 'My layouts',
    suggested: 'Suggested',
    create: 'New layout',
    createDescription: 'Give your new layout a name. You can build its structure next.',
    namePlaceholder: 'Layout name',
    rename: 'Rename',
    renameTitle: 'Rename layout',
    duplicate: 'Duplicate',
    delete: 'Delete',
    deleteTitle: 'Delete layout?',
    deleteDescription: 'This action cannot be undone. Dashboard assignments to this layout will be lost.',
    addSlot: 'Add slot',
    removeSlot: 'Remove slot',
    addToSlot: 'Add dashboard',
    unassignSlot: 'Remove from slot',
    suggestedReadOnly: 'Suggested layout cannot be edited. Duplicate to customize.',
    saveError: 'Error saving layout',
    unassignedBanner_one: '{{count}} dashboard does not fit in this layout and is hidden.',
    unassignedBanner_other: '{{count}} dashboards do not fit in this layout and are hidden.',
    useFreeGrid: 'Show all',
    switcherAria: 'Switch layout (current: {{name}})',
    emptySlotAria: 'Empty {{type}} slot',
    copySuffix: '(copy)',
  },

  // PBI #78540 — Cascading dashboard preferences (3-layer inheritance) UX.
  defaults: {
    menuTitle: 'Save as Default',
    forOrganization: 'Organization',
    forWorkspace: 'Workspace',
    forSuperadmin: 'Superadmin',
    forAllOrgs: 'All Organizations',
    forAllWorkspaces: 'All Workspaces',
    confirmTitle: 'Confirm',
    confirmOrg: 'Save this layout as the organization default? Users without their own layout will start to see it.',
    confirmWorkspace: 'Save this layout as the workspace default? Users without their own layout for this workspace will start to see it.',
    confirmSuperadmin: 'Save this layout as the Superadmin screen default? All superadmins without their own layout will start to see it.',
    confirmAllOrgs: 'Save this layout as the global default for ALL organizations? Orgs without their own layout and users without customization will start to see it.',
    confirmAllWorkspaces: 'Save this layout as the global default for ALL workspaces? Workspaces without their own layout and users without customization will start to see it.',
    savedOrg: 'Layout saved as the organization default.',
    savedWorkspace: 'Layout saved as the workspace default.',
    savedPlatform: 'Layout saved as global default.',
    saveError: 'Failed to save as default.',
    resetPreferences: 'Clear Preferences',
    resetTitle: 'Clear preferences?',
    resetSuperadminMsg: 'Your superadmin preferences will be deleted. You will start to see the platform global default layout. This cannot be undone.',
    resetOrgMsg: 'Your preferences for this organization will be deleted. You will start to see the organization default layout (or the global one, if none). This cannot be undone.',
    resetWorkspaceMsg: 'Your preferences for this workspace will be deleted. You will start to see the workspace default layout (or the global one). This cannot be undone.',
    resetConfirm: 'Clear',
    resetSuccess: 'Preferences cleared.',
    resetError: 'Failed to clear preferences.',
  },

  tabs: {
    addTab: 'Add tab',
    add: 'Add tab',
    rename: 'Rename',
    renameTitle: 'Rename tab',
    duplicate: 'Duplicate',
    delete: 'Delete',
    deleteTitle: 'Delete tab?',
    deleteDescription: 'This cannot be undone. The dashboards and layouts in this tab will be lost.',
    options: 'Tab options',
    namePlaceholder: 'Tab name',
    defaultName: 'Main',
  },

  // Templates admin page (Settings > Templates > Dashboards).
  templatesAdmin: {
    searchPlaceholder: 'Search by name, scope, type or category...',
    newTemplate: 'New template',
    columnName: 'Name',
    columnScope: 'Scope',
    columnType: 'Type',
    columnCategory: 'Category',
    columnActive: 'Active',
    columnActions: 'Actions',
    emptySearch: 'No templates match this search.',
    emptyInitial: 'No templates yet. Click "New template" to get started.',
    actionPublish: 'Publish to all instances',
    actionEdit: 'Edit',
    actionDeactivate: 'Deactivate',
    deactivateTitle: 'Deactivate template?',
    deactivateDescription: 'The template will be deactivated (it will no longer be distributed to new organizations/products). Existing instances in dashboards_base remain untouched.',
    deactivateConfirm: 'Deactivate',
    publishTitle: 'Publish template?',
    publishDescriptionOrgs: 'The template <strong>{{name}}</strong> will be installed in every active organization that does not already have an instance. This operation is idempotent — existing instances will not be overwritten.',
    publishDescriptionProducts: 'The template <strong>{{name}}</strong> will be installed in every active product that does not already have an instance. This operation is idempotent — existing instances will not be overwritten.',
    publishConfirm: 'Publish',
    publishing: 'Publishing...',
    cancel: 'Cancel',
    toastDeactivated: 'Template deactivated',
    toastSuperadminNoInstances: 'Superadmin templates do not generate instances.',
    toastPublishSummary: 'Published: {{installed}} new / {{skipped}} already existed / {{failed}} failed (across {{targets}} {{scopeLabel}}).',
    scopeLabelOrgs: 'orgs',
    scopeLabelProducts: 'products',
  },
};

export default dashboards;
